import { Box } from 'ui/Box';
import { Button } from 'components/Button';
import { PlusIcon } from 'components/icons/PlusIcon';
import { FC } from 'react';
import { Typography } from 'ui/Typography';

export interface QAButtonsProps {
  onAddQAOpen: () => void;
  onUploadDocument: () => void;
}
export const QAButtons: FC<QAButtonsProps> = ({
  onAddQAOpen,
  onUploadDocument,
}) => {
  return (
    <Box className="flex flex-wrap gap-2 md:flex-nowrap">
      <Button
        variantType="outlined"
        className="w-full px-5 md:max-w-max"
        onClick={onAddQAOpen}
      >
        <PlusIcon className="h-6 w-6" />
        <Typography>Add a New Q&A</Typography>
      </Button>
      <Button
        variantType="outlined"
        className="w-full px-5 md:max-w-max"
        onClick={onUploadDocument}
      >
        <PlusIcon className="h-6 w-6" />
        <Typography>Upload the document</Typography>
      </Button>
    </Box>
  );
};
